import { Password, TextFields } from '@mui/icons-material'
import { Button, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { useState } from 'react'
import { useAppDispatch } from '../redux/hooks'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom'
import { LoginAdmin } from '../redux/actions';
// import '../globals/entryFormStyles.scss'

interface LoginPropTypes {

}

interface FormState {
  email?: string,
  password?: string
}

const Login = (props : LoginPropTypes) => {
  const [formState, setFormState] = useState<FormState>({});
  const [isValidForSubmission, setIsValidForSubmission] = useState<boolean>(true);
  const dispatch = useAppDispatch();

  let formError = ""
  if(formState.email) {
    const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (reg.test(formState.email) === false) {
        formError = "Invalid Email Address" 
      }
  }

  if(formState.password) {
    if(formState.password.length < 8) {
      formError = "Password must be greater than 8 characters long"
    }
  }


  if(!formError && formState.email && formState.password) {
    if(!isValidForSubmission) {
      setIsValidForSubmission(true)
    }
  }
  else {
    if(isValidForSubmission) {
      setIsValidForSubmission(false)
    }
  }

  const handleSubmit = () => {
    if(isValidForSubmission) {
      if( formState?.email && formState?.password) {
        dispatch(LoginAdmin({
          email: formState.email,
          password: formState.password
        }))
      }
    }
  }

  return (
    <div className='entryForm muiInputWrapper'>
      <h2>
      Admin Login 
      </h2>
      {

        formError ?
          <Button
            variant='contained'
            color='error'
            className='warningButton'
          >
            {formError}
          </Button>
        :
          null
      }

      <label>Email</label>
      <TextField
          onChange={(e) => setFormState({...formState, email: e.target.value})}
          variant="outlined"
        />
      <label>Password</label>
      <TextField
          onChange={(e) => setFormState({...formState, password: e.target.value})}
          variant="outlined"
          type='password'
        />
      <Button
        className={`button${!isValidForSubmission ? ' disabled' : ''}`}
        variant='outlined'
        disabled={!isValidForSubmission}
        onClick={() => {handleSubmit()}}
        sx={{
            marginTop: "40px"
        }}
      >SUBMIT&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ArrowForwardIcon/></Button>
    </div>
  )
}

Login.propTypes = {}

export default Login